import React, { useEffect, useState } from "react";
import { Row, Col, Space, Spin } from "antd";
import { useSelector } from "react-redux";

import TopBar from "./components/TopBar";
import ListView from "./components/ListView";
// import Board from "./components/Board";
import FiltersBar from "./components/FiltersBar";
import IssueDetails from "./components/issueDetails";
import { api } from "../../../services/api";
import { useLocation, useNavigate } from "react-router-dom";

export default function TicketingView() {
  const [loader, setLoader] = useState(false);
  const [selectedIssue, setSelectedIssue] = useState<any | null>(null);
  const [tickets, setTickets] = useState<any>({});
  const [user, setUser] = useState<any>({});

  const [filters, setFilters] = useState({
    status: null,
    priority: null,
    type: null,
    assignee: null,
    title: "",
  });
  const boardView = useSelector((state: any) => state.board.boardView);
  const [menuId, setMenuId] = useState<string | null>(null);
  const location = useLocation(); // Use useLocation hook to get the state
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState<any>({});

  // If a new ticket was created, add it to the ticket list

  const [type, setType] = useState<any>([]);

  useEffect(() => {
    fetchTicketType();
  }, []);

  const fetchTicketType = async () => {
    let body = {
      filter: {
        keyGroup: "ticket",
        category: "ticketType",
        "attributes.active": true,
      },
      projection: {
        value: 1,
        label: "$label.EN",
        _id: 0,
      },
    };

    try {
      let result = await api.getTicketType(body);
      setType(result);
    } catch (error) {}
  };

  const handleIssueClick = (issue: any) => {
    console.log("🚀 ~ handleIssueClick ~ ticketId:", issue);
    // Navigate to the detail page for the selected issue
    navigate(`/ticketing/details/${issue.id}`);
  };

  useEffect(() => {
    if (location.state?.newTicket) {
      setTickets((prevTickets) => ({
        ...prevTickets,
        data: [location.state.newTicket, ...prevTickets.data], // Add the new ticket at the top
      }));
    }
  }, [location.state?.newTicket]);

  const getUserPermissions = async () => {
    const data = JSON.parse(await window.localStorage.getItem("menu-list"));
    if (data?._id) {
      setMenuId(data?._id);
      setPermissions(data?.data);
    }
  };

  useEffect(() => {
    getUserPermissions();
  }, []);

  // useEffect(() => {
  //   if (menuId) {
  //     fetchTicketsList(menuId, permissions);
  //   }
  // }, [filters, menuId]);

  useEffect(() => {
    if (!menuId) return;
    fetchTicketsList(menuId, permissions);
  }, [filters]);

  useEffect(() => {
    if (menuId) {
      fetchTicketsList(menuId, permissions);
    }
  }, [menuId]);

  const fetchTicketsList = async (_id: string, permissions: any) => {
    setLoader(true);
    try {
      const response = await api.getTickets(filters, _id, permissions);

      setTickets(response);
      setUser(response?.user);
    } catch (error) {
      console.error("Error fetching Ticket list:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <>
      <Row gutter={24}>
        <Col span={24}>
          <TopBar
            showSearch={boardView === "board"}
            ticketCount={tickets.count}
            loading={loader}
          />

          {!selectedIssue && boardView === "board" && <FiltersBar />}

          {boardView === "board" ? (
            <></>
          ) : (
            // <Board onIssueClick={setSelectedIssue} />
            <ListView
              onIssueClick={handleIssueClick}
              data={tickets}
              user={user}
              types={type}
              filters={filters}
              onFilterChange={handleFilterChange}
            />
          )}
        </Col>
      </Row>
    </>
  );
}
